// extracted by mini-css-extract-plugin
module.exports = {"switch":"_9e1425b4d3--switch--VneCO","indicator":"_9e1425b4d3--indicator--ApXPO","disabled":"_9e1425b4d3--disabled--J5kyp"};